<template>
    <section :class="spectrumHeroBackgroundImage" class="spectrum-hero" :style="{ marginTop: isEventBannerVisible ? '0px' : '90px' }">
      <div class="container-fluid">
        <v-row >
          <v-col xl="4" lg="4" md="4" cols="12" class="p-0 d-flex flex-column justify-content-center align-items-center" :style="{ marginTop: marginTopStyle }">
            <div class="mt-3 banner-info">
              <div class="ml-2 mb-3">
                <div class="mb-2 banner-info-main-text" :class="bannerMainInfoTextClasses">{{ infoTextMap[selectedSegment ?? 'ProjectSpectrum'].mainText }}</div>
                <div class="banner-info-sub-text" :class="primaryInfoSubTextClasses">What's in it for me?</div>
              </div>

              <div class="ml-2 mb-4">
                <div class="d-flex flex-row justify-content-start align-items-start">
                  <img style="object-fit: contain;" src="../../../assets/images/logo/check.png" alt="">
                  <div class="ml-2 banner-info-sub-text" :class="secondaryInfoSubTextClasses">{{ infoTextMap[selectedSegment ?? 'ProjectSpectrum'].subText1 }}</div>
                </div>
                <div class="mt-2 d-flex flex-row justify-content-start align-items-start">
                  <img style="object-fit: contain;" src="../../../assets/images/logo/check.png" alt="">
                  <div class="ml-2 banner-info-sub-text" :class="secondaryInfoSubTextClasses">{{ infoTextMap[selectedSegment ?? 'ProjectSpectrum'].subText2 }}</div>
                </div>
              </div>

              <BannerButtons
                :buttonTitle="buttonLabel"
                :button-color="buttonColorMap[selectedBlueprint]"
                :vButtonFirstItemClass="'banner-buttons-xl-lg-md'"
                :vButtonSecondItemClass="'banner-buttons-xl-lg-md'"
                :bannerButtonClasses="'ml-2 mb-3 d-none d-xl-flex d-lg-flex d-md-flex flex-row justify-content-start'"
                @goToBlueprintItem="autoScrollToBlueprint"
              />

            </div>
          </v-col>
          <v-col xl="8" lg="8" md="8" cols="12" class="p-0">
            <SpectrumWheel 
              :selectedSegmentName="selectedBlueprint"
              @receive-selected-segment="receiveSegmentName"
              @back-button-click="handleBackButtonClick"
            />
          </v-col>
        </v-row>

        <v-row class="d-flex d-xs-flex d-none d-sm-flex d-md-none d-lg-none d-xl-none">
          <v-col cols="12" class="p-0">

            <BannerButtons
              :buttonTitle="buttonLabel"
              :button-color="buttonColorMap[selectedBlueprint]"
              :bannerButtonClasses="mobileBannerButtonClassesComputed"
              :vButtonSecondItemClass="buttonLabel && 'mt-3'"
              @goToBlueprintItem="autoScrollToBlueprint"
            />

          </v-col>
        </v-row>
      </div>
    </section>
</template>

<script>
import SpectrumWheel from './spectrum-wheel.vue';
import BannerButtons from '../../library/buttons/banner-buttons.vue';

export default {
  name: "SpectrumHero",
  components: {
    SpectrumWheel,
    BannerButtons,
  },
  props: {
    selectedBlueprint: String,
    isEventBannerVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSegment: undefined,
      buttonMap: {
        'Cybersecurity': 'Get Cyber-Secure',
        'ProjectSpectrum': 'What is Project Spectrum?',
        'SpectrumManufacturers': 'Learn More',
        'UnderstandingData': 'Why is this important?',
        'BusinessTools': 'Build Your Toolbox!',
        'CMMC': 'What is CMMC?',
        'NIST800-171': 'What is NIST?',
      },
      buttonColorMap: {
        'Cybersecurity': '#8BC5EB',
        'ProjectSpectrum': '#424EC4',
        'SpectrumManufacturers': '#00A28E',
        'UnderstandingData': '#E50088',
        'BusinessTools': '#FFFFFF',
        'CMMC': '#00AFF7',
        'NIST800-171': '#FF504D',
      },
      infoTextMap: {
        'Cybersecurity': {
          mainText: 'Securing the Defense Industrial Base',
          subText1: 'Learn about the most common and dangerous cyber threats',
          subText2: 'Protect yourself against malicious actors',
        }, 
        'ProjectSpectrum': {
          mainText: 'Make Your Small Business Cyber Secure',
          subText1: 'Unlock more potential government contract opportunities',
          subText2: 'Improve cybersecurity readiness, resiliency, and compliance',
        }, 
        'SpectrumManufacturers': {
          mainText: 'Cyber Resources for the Supply Chain',
          subText1: 'Cybersecurity assistance for the federal manufacturing supply chain',
          subText2: 'Achieve compliance to bid on current/future government contracts',
        }, 
        'UnderstandingData': {
          mainText: 'Know Where to Start',
          subText1: 'Understand the types of data your organization will process',
          subText2: 'Implement cyber protection based on identified data',
        }, 
        'BusinessTools': {
          mainText: 'Know What Works Best',
          subText1: 'Reviews of cybersecurity tools and services',
          subText2: 'An arsenal of safeguards against cyber threats',
        }, 
        'CMMC': {
          mainText: 'Cybersecurity Maturity Model Certification',
          subText1: 'Understand the requirements to secure lucrative government contracts',
          subText2: 'Stay up to speed on evolving standards',
        }, 
        'NIST800-171': {
          mainText: 'Cyber Resources for the Supply Chain',
          subText1: 'Understand government information security standards and guidelines',
          subText2: 'Stay abreast of contracting requirements for small- and medium-sized businesses',
        }, 
      },
    };
  },
  computed: {
    mobileBannerButtonClassesComputed() {
      return this.buttonLabel ? 'mt-4 mb-4 d-flex flex-column justify-content-center align-items-center' : 'mb-4 d-flex flex-row justify-content-center';
    },
    spectrumHeroBackgroundImage() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? 'spectrum-hero-mobile-background' : 'spectrum-hero-desktop-background';
    },
    bannerMainInfoTextClasses() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? 'banner-info-main-text-sm-xs' : 'banner-info-main-text-md-lg-xl';
    },
    primaryInfoSubTextClasses() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? 'primary-info-sub-text-sm-xs' : 'primary-info-sub-text-md-lg-xl';
    },
    secondaryInfoSubTextClasses() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? 'secondary-info-sub-text-sm-xs' : 'secondary-info-sub-text-md-lg-xl';
    },
    buttonLabel() {
      return this.selectedSegment ? this.buttonMap[this.selectedSegment] : undefined;
    },
    marginTopStyle() {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs) ? '20px' : '0';
    }
  },
  methods: {
    receiveSegmentName(selectedSegmentName) {
      this.selectedSegment = selectedSegmentName;
      this.$emit("send-selected-segment", selectedSegmentName);
    },
    handleBackButtonClick() {
      this.selectedSegment = undefined; // Reset the selected segment
      this.$emit("back-button-clicked"); // Make sure the event name matches what the parent expects
    },
    autoScrollToBlueprint() {
      this.$emit("scroll-to-blueprint");
    }
  },
  watch: {
  selectedBlueprint(newValue) {
    if(newValue) {
      this.selectedSegment = newValue;
      console.log(`Selected Segment => ${newValue}`);
    }
  },
  '$route.query.segment': {
    handler(newValue) {
      if(newValue) {
        this.selectedSegment = newValue;
      } else {
        this.selectedSegment = undefined;
      }
    },
    immediate: true
  }
},
}
</script>

<style scoped>

.spectrum-hero {
	background-size: cover;
  min-width: 340px;
  padding-bottom: 80px;
}

.spectrum-hero-desktop-background {
  background-image: url('../../../assets/images/HomepageBannerBackgroundHeaderDesktop2.jpg');
}

.spectrum-hero-mobile-background {
  background-image: url('../../../assets/images/HomepageBannerBackgroundHeaderMobile.png');
  background-position: center 90%;
}

.banner-info {
  width: 90%;
  margin-bottom: 10px;
}
.banner-info-main-text-md-lg-xl {
  font-size: clamp(20px, 5vw, 36px);
  line-height: clamp(24px, 5vw, 38.4px);
  color: #ffffff;
}
.banner-info-main-text-sm-xs {
  font-size: clamp(15px, 3vw, 20px);
  line-height: clamp(16px, 3vw, 24px);
  color: #7CDBFF;
}
.banner-info-main-text {
  font-family: GeomGraphic;
  font-weight: 400;
  text-align: left;
  word-wrap: break-word;
}
.primary-info-sub-text-md-lg-xl {
  font-size: 16px;
  font-weight: 600;
}
.primary-info-sub-text-sm-xs {
  font-weight: 500;
}
.secondary-info-sub-text-md-lg-xl {
  font-size: 16px;
  font-weight: 600;
}
.secondary-info-sub-text-sm-xs {
  font-weight: 400;
}
.banner-info-sub-text {
  color: #E6E6E6;
  font-family: Rajdhani;
  font-size: clamp(14px, 2vw, 16px);
  font-style: normal;
  line-height: normal;
  text-align: left;
  word-wrap: break-word;
}
</style>